export const credentialsType = (credentials = ''): number => +credentials[3];
export const isCompounding = (credentials: string) =>
  credentialsType(credentials) === 2;

export default credentialsType;
